/**
 * Index Controller
 */
/*
  globals moment
*/
(function(angular) {
    'use strict';

    var app = angular.module('asSecureCommerce');

    app.controller('PentestInsightsIndexController', [
        '$scope',
        '$window',
        '$timeout',
        '$http',
        function($scope, $window, $timeout, $http) {
            var loader = $('#application-templates').find('#load-message').clone();                                    
            
            $scope.getReport = function(task_id) {
                $scope.reports = loader.html();
                
                $http.post('/se/pentestInsights', {task_id: task_id}).then(
                    // success
                    function(res) {
                      if (res.data.status === 'success') {
                        $scope.reports = res.data.reports;
                      } else {
                        $scope.reports = 'error occured.';
                      }
                    },
                    // error
                    function(res) {
                      $scope.reports = 'error occured.';
                    }                
                );
            };
            
            $scope.getReport($window.getSelectedTask());
        }
    ]);
})(window.angular);
